import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import ArticleContent from './ArticleContent';
import { getQueryParams } from '../../services/UtilityService';
import ArticleService from '../../services/ArticleService';

const TTGArticlePdf = () => {
	const location = useLocation();
	const params = getQueryParams(location.search);
	const article = ArticleService.getArticleData(params);

	return (
		<div className='ttg-article-pdf'>
			<Helmet>
				<meta charSet='UTF-8' />
				<meta name='viewport' content='width=device-width, initial-scale=1.0' />
				<meta httpEquiv='X-UA-Compatible' content='ie=edge' />
				<title>{article?.title ? `${article.title} | The Table Group` : 'The Table Group Article Pdf'}</title>
			</Helmet>
			{article && <ArticleContent article={article} />}
		</div>
	);
};

export default TTGArticlePdf;
